export const capitalizationNoneType = {
  id: 'none',
  value: 'none',
  name: 'Nenhuma',
};

export const capitalizationSemianualType = {
  id: 'semiannual',
  value: 'semiannual',
  name: 'Semestral',
};
export const capitalizationFourmonthsType = {
  id: 'fourmonths',
  value: 'fourmonths',
  name: 'Quadrimestral',
};
export const capitalizationQuarterlyType = {
  id: 'quarterly',
  value: 'quarterly',
  name: 'Trimestral',
};
export const capitalizationBimonthlyType = {
  id: 'bimonthly',
  value: 'bimonthly',
  name: 'Bimestral',
};
export const capitalizationMonthlyType = {
  id: 'monthly',
  value: 'monthly',
  name: 'Mensal',
};
export const capitalizationYearlyType = {
  id: 'yearly',
  value: 'yearly',
  name: 'Anual',
};
export const capitalizationTypes = [
  capitalizationMonthlyType,
  capitalizationBimonthlyType,
  capitalizationFourmonthsType,
  capitalizationNoneType,
  capitalizationQuarterlyType,
  capitalizationSemianualType,
  capitalizationYearlyType,
];

export default capitalizationTypes;
